import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

const className = "sheepsteakmeat";

function GISheepSteakMeat() {
  return (
    <ItemPresenter imagePath={`/images/gameItems/${className}.png`} tooltipText={className} />
  );
}

export default GISheepSteakMeat;